import { useStore } from '../store/index'

/** Código de idioma de la web -> og:locale. */
const OG_LOCALE: Record<string, string> = {
  es: 'es_ES', en: 'en_US', ca: 'ca_ES', eu: 'eu_ES', fr: 'fr_FR', de: 'de_DE', it: 'it_IT', nl: 'nl_NL',
  no: 'nb_NO', pl: 'pl_PL', ro: 'ro_RO', ru: 'ru_RU', sv: 'sv_SE', zh: 'zh_CN', ar: 'ar_SA'
}
export const ogLocale = (idioma: string) => OG_LOCALE[idioma] || idioma

/** Texto sin etiquetas HTML ni entidades, en una sola línea. */
export function textoPlano(html: any): string {
  return String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'")
    .replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim()
}

/** Recorta en una palabra entera y añade puntos suspensivos si hace falta. */
export function recortar(texto: string, max: number): string {
  if (texto.length <= max) return texto
  const corte = texto.slice(0, max - 1)
  const espacio = corte.lastIndexOf(' ')
  return (espacio > max * 0.6 ? corte.slice(0, espacio) : corte).replace(/[\s,.;:]+$/, '') + '…'
}

/** Fecha de un contenido de la web ("2026-10-25 10:00:00" o "25/10/2026") en formato ISO (AAAA-MM-DD), o undefined. */
export function fechaIso(fecha: any): string | undefined {
  const s = String(fecha ?? '').trim()
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return `${m[1]}-${m[2]}-${m[3]}`
  m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/)
  if (m) return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`
  return undefined
}

/**
 * URLs públicas de la página actual en cada idioma de la web.
 * El primer idioma de la lista es el principal y va sin prefijo (`/servicios`); los demás llevan `/en/servicios`.
 */
export function useSeoUrls() {
  const store = useStore()
  const route = useRoute()

  const origen = `https://${store.host}`
  const idiomas: string[] = ((store.languages as any[]) || []).map((l: any) => l.Language).filter(Boolean)
  if (!idiomas.length) idiomas.push('es')
  const principal = idiomas[0]
  const idioma = idiomas.includes(store.idioma) ? store.idioma : principal

  // Ruta de la página sin prefijo de idioma ni barra final ("/" en la portada)
  let ruta = route.path
  const lang = route.params?.lang
  if (typeof lang === 'string' && (ruta === `/${lang}` || ruta.startsWith(`/${lang}/`))) ruta = ruta.slice(lang.length + 1)
  ruta = '/' + ruta.replace(/^\/+|\/+$/g, '')

  /** URL absoluta de una ruta (por defecto la actual) en un idioma. */
  function url(idiomaUrl: string, path: string = ruta): string {
    const base = idiomaUrl === principal ? '' : '/' + idiomaUrl
    return origen + base + path
  }

  /** Alternativas por idioma (hreflang), solo si la web tiene más de uno. */
  const alternativas = idiomas.length > 1
    ? [...idiomas.map((l) => ({ hreflang: l, href: url(l) })), { hreflang: 'x-default', href: url(principal) }]
    : []

  return { origen, idiomas, principal, idioma, ruta, url, alternativas }
}
